export default "__VITE_ASSET__BVe$u4LF__"